import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
import { COUNTDOWN_SECONDS } from '../data/site';
interface CountdownProps {
  label?: string;
  variant?: 'light' | 'dark';
}
function pad(value: number) {
  return String(value).padStart(2, '0');
}
export function Countdown({
  label = 'This price expires in',
  variant = 'light'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(COUNTDOWN_SECONDS);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? COUNTDOWN_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const hrs = Math.floor(remaining / 3600);
  const min = Math.floor(remaining % 3600 / 60);
  const sec = remaining % 60;
  const cellClass = variant === 'dark' ? 'bg-white/10 text-white ring-1 ring-white/20' : 'bg-navy-700 text-white shadow-soft';
  const labelClass = variant === 'dark' ? 'text-white/70' : 'text-ink-muted';
  const unitClass = variant === 'dark' ? 'text-white/60' : 'text-ink-muted';
  const units = [{
    value: hrs,
    unit: 'HRS'
  }, {
    value: min,
    unit: 'MIN'
  }, {
    value: sec,
    unit: 'SEC'
  }];
  return <div className="flex flex-col items-center" data-id="element-22" data-mp="17r9cr6xgfdng">
      <p className={`flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.18em] ${labelClass}`} data-id="element-23" data-mp="17t2huhsf5ptc">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-24" data-mp="f22hqhx7l66y" />
        {label}
      </p>
      <div className="mt-2.5 flex items-start gap-1.5 sm:gap-2" role="timer" aria-live="off" aria-label={`${pad(hrs)} hours ${pad(min)} minutes ${pad(sec)} seconds remaining`} data-id="element-25" data-mp="a37osn5j2194">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-26" data-mp="k0lym3wy3rsg" data-mpi={i}>
            {i > 0 && <span className={`pt-2.5 text-xl font-bold ${variant === 'dark' ? 'text-white/40' : 'text-navy-200'}`} aria-hidden="true" data-id="element-27" data-mp="1zhmfve40q07s">
                :
              </span>}
            <div className="flex flex-col items-center" data-id="element-28" data-mp="s54xt5c6dlmu">
              <span className={`flex h-14 w-[3.75rem] items-center justify-center rounded-xl text-2xl font-extrabold tabular-nums sm:h-16 sm:w-[4.5rem] sm:text-3xl ${cellClass}`} data-id="element-29" data-mp="x484svbpu1xg">
                {pad(u.value)}
              </span>
              <span className={`mt-1 text-[10px] font-bold tracking-[0.14em] ${unitClass}`} data-id="element-30" data-mp="163bn3x326daw">
                {u.unit}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}